import React, { Fragment } from 'react';
import DataTable from 'react-data-table-component';
import { convertDate, convertDateTime, formatCurrency } from '../../../../Library/custom_utils';
import { H3, H6 } from '../../../../AbstractElements';
import MothriftLoader from '../../Common/MothriftLoader';

const tableColumns = [
  {
    name:     'Customer Name',
    selector: row => row.customerName,
    width:    '200px',
  },
  {
    name:     'User ID',
    selector: row => row.userId,
  },
  {
    name:     'Interest',
    selector: row => row.amount,
  },
  {
    name:     'Date',
    selector: row => row.date,
    center:   true,
  },
  {
    name:     'Term',
    selector: row => row.fixTypeLabel,
    center:   true,
  },
  {
    name:     'Date Started',
    selector: row => row.fixStarted,
    center:   true,
  },
  {
    name:     'End Date',
    selector: row => row.fixEnded,
    center:   true,
  },
  {
    name:     'Principal Amount',
    selector: row => row.fixAmount,
    center:   true,
    width:    '150px'
  },
];

const EarnHistoryTable = ({
  data,
  isLoading,
  totalRows,
  currentPage,
  onPageChange,
  limit,
}) => {

  const renderItem = (item) => {
    const customerName = `${item?.firstName || ''} ${item?.lastName || ''}`.trim() || 'N/A';
    const termDisplay = item.fixType === 1 ? '2 hours' : `${item.fixType} days`;

    return {
      customerName: <H6 attrH6={{ className: 'f-14 f-light text-uppercase' }}>{customerName}</H6>,
      userId:       <H6 attrH6={{ className: 'f-14 f-light' }}>{item.userId}</H6>,
      amount:       <H3 attrH3={{ className: 'f-14 mb-0 font-success font16-bold' }}>{formatCurrency(item.amount)}</H3>,
      date:         <H6 attrH6={{ className: 'f-14 mb-0 f-light' }}>{convertDateTime(item.date)}</H6>,
      fixTypeLabel: <H6 attrH6={{ className: 'f-14 mb-0 f-light' }}>{termDisplay}</H6>,
      fixStarted:   <H6 attrH6={{ className: 'f-14 mb-0 f-light' }}>{convertDate(item.fixStarted)}</H6>,
      fixEnded:     <H6 attrH6={{ className: 'f-14 mb-0 f-light' }}>{convertDate(item.fixFinished)}</H6>,
      fixAmount:    <H3 attrH3={{ className: 'f-14 mb-0 font-info font16-bold' }}>{formatCurrency(item.fixAmount)}</H3>,
    };
  };

  return (
    <Fragment>
      {isLoading ? (
        <MothriftLoader />
      ) : (
        <DataTable
          data={data.map(item => renderItem(item))}
          columns={tableColumns}
          striped
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          paginationPerPage={limit}
          paginationDefaultPage={currentPage}
          onChangePage={onPageChange}
          paginationResetDefaultPage={false}
          persistTableHead
          customStyles={{
            table: {
              style: {
                minHeight: 'auto', // Fixes the height issue during searches
              },
            },
            headCells: {
              style: {
                fontWeight: '700',
                fontSize: '13px',
                backgroundColor: '#f8f9fa',
              }
            },
            rows: {
              style: {
                minHeight: '60px',
              }
            }
          }}
        />
      )}
    </Fragment>
  );
};

export default EarnHistoryTable;